/**
 * Normalizes a Polish street address from XLSX import.
 *
 * Rules applied (in order):
 * 1. Trim leading/trailing whitespace
 * 2. Remove street-type prefixes: ul., Ul., UL., ulica, Ulica
 *    al., Al., AL., aleja, Aleja
 *    The dot is REQUIRED for abbreviated forms (ul., al.) to avoid stripping
 *    street names that start with "al" or "ul" (e.g. "Albatrosów", "Ulewa").
 * 3. Collapse multiple internal spaces to one
 * 4. Re-trim after collapsing
 *
 * NOT done (out of scope, risk of data corruption):
 * - Transliteration / diacritic restoration (Nowy Swiat → Nowy Świat)
 * - Abbreviation expansion (Pl. → Plac)
 * - Case normalization of proper nouns
 *
 * Returns null/empty as-is (caller decides whether to reject).
 */
export function normalizeAddress(raw: string | null | undefined): string {
  if (!raw) return raw ?? '';

  let s = raw.trim();

  // Remove street-type prefixes at start of string (case-insensitive).
  // Word forms (ulica, aleja) must be followed by whitespace to avoid matching
  // "ulicami" or "alejowy". Abbreviated forms (ul., al.) require the dot — making
  // it optional would match plain "ul" or "al" at the start of proper street names
  // like "Albatrosów" or "Ulewa". Zero or more spaces after the dot handle
  // "ul.Świdnicka" (no space after dot).
  s = s.replace(/^(ulica\s+|aleja\s+|ul\.\s*|al\.\s*)/i, '');

  // Collapse multiple spaces
  s = s.replace(/\s{2,}/g, ' ').trim();

  return s;
}
